import Default from "@/modules/post/pages/posts/Default"
import Notes from "@/modules/post/pages/posts/Notes"
import PostsDrafts from "@/modules/post/pages/posts/PostsDrafts"
import NotesDrafts from "@/modules/post/pages/posts/NotesDrafts"
import ArticlesDrafts from "@/modules/post/pages/posts/ArticlesDrafts"
import PromocodeDrafts from "@/modules/post/pages/posts/PromocodeDrafts"
import authMiddleware from "@/plugins/router/middlewares/auth"
import PostCreate from "@/modules/post/pages/create/Index"
import PostUpdate from "@/modules/post/pages/update/Index"
import PostView from "@/modules/post/pages/view/Index"
import Search from "@/modules/post/pages/search/Default"
import PostsNotModerated from "@/modules/post/pages/posts/PostsNotModerated"
import NotesNotModerated from "@/modules/post/pages/posts/NotesNotModerated"
import Ranking from "@/modules/post/pages/ranking/Ranking"
import Promocode from "@/modules/post/pages/posts/Promocode"
import Articles from "@/modules/post/pages/posts/Articles"
import Tags from "@/modules/post/pages/tags/Tags"
import PostDuplicate from "@/modules/post/pages/duplicate/Index"
import Statistic from "@/modules/post/pages/statistic/Statistic"

export default [{
    path: "/post/view/:id(\\d+)",
    name: "PostView",
    component: PostView,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/post/edit/:id(\\d+)",
    name: "PostUpdate",
    component: PostUpdate,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/post/create/:channel_id(\\d+)",
    name: "PostCreate",
    component: PostCreate,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/post/notes",
    name: "Notes",
    component: Notes,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/post/posts/:channel_id(\\d+)",
    name: "Posts",
    component: Default,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/post/posts-drafts/:channel_id(\\d+)",
    name: "PostsDrafts",
    component: PostsDrafts,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/post/notes-drafts",
    name: "NotesDrafts",
    component: NotesDrafts,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/post/promocode-drafts",
    name: "PromocodeDrafts",
    component: PromocodeDrafts,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/post/articles-drafts",
    name: "ArticlesDrafts",
    component: ArticlesDrafts,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/post/search",
    name: "Search",
    component: Search,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/post/posts-not-moderated",
    name: "PostsNotModerated",
    component: PostsNotModerated,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/post/notes-not-moderated",
    name: "NotesNotModerated",
    component: NotesNotModerated,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/post/ranking",
    name: "Ranking",
    component: Ranking,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/post/promocode",
    name: "Promocode",
    component: Promocode,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/post/articles",
    name: "PostArticles",
    component: Articles,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/post/tags",
    name: "PostTags",
    component: Tags,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/post/duplicate/:channel_id(\\d+)",
    name: "PostDuplicate",
    component: PostDuplicate,
    meta: {
        middleware: authMiddleware,
    },
}, {
    path: "/statistic",
    name: "Statistic",
    component: Statistic,
    meta: {
        middleware: authMiddleware,
    },
}]
